import AssignmentView from "@/features/assignment";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { NavigationItems } from "@/shared/types/navigation";

export function Assignment() {
  useDocumentTitle(NavigationItems.LOD_ASSIGNMENT.name);

  return <AssignmentView />;
}
